import ContactFooter from "../components/ContactFooter";
import HeroText from "../components/HeroText";
import React from "react";
import { useTranslation } from "react-i18next";
import HelmetSeo from "../components/Reusable/HelmetSeo";

const DeliveryPage = () => {
  const { t } = useTranslation();
  const heroData = {
    title: t("delivery_page.title"),
  };

  return (
    <div className="terms-holder-content">
      <HelmetSeo title={"Fuka | " + t("delivery_page.title")} />
      <div className="container">
        <div className="terms-hero-holder">
          <HeroText data={heroData} />
        </div>
        <div className="terms-content-main">
          <div dangerouslySetInnerHTML={{ __html: t("delivery_page.body") }} />
        </div>
        <ContactFooter />
      </div>
    </div>
  );
};

export default DeliveryPage;
